// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"976b659c","455":"12305083","977":"cb45156e"}[chunkId] + ".chunk.js";
};